import { ResetPasswordPage } from '../../identity/pages/ResetPasswordPage';
import { PARTNER_RESET_NEW_PASSWORD_SLIDES } from '../heroSlides';

/** EPN-36 — thin wrapper reusing ResetPasswordPage's entire `POST /api/auth/password/reset` flow
 * (token validation, complexity check, success state) unmodified; only the hero image, heading, and Sign
 * In/Forgot Password destinations differ. See ResetPasswordPageProps' own doc comment for the one
 * disclosed design-vs-reality gap (no live password-rule checklist). */
export function PartnerResetPasswordPage() {
  return (
    <ResetPasswordPage
      heroSlides={PARTNER_RESET_NEW_PASSWORD_SLIDES}
      signInHref="/partner-login"
      forgotPasswordHref="/partner-forgot-password"
      heading="Reset Password"
    />
  );
}
